import { render, staticRenderFns } from "./TestPackageAdd.vue?vue&type=template&id=00e7b19c"
import script from "./TestPackageAdd.vue?vue&type=script&lang=js"
export * from "./TestPackageAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports